import "@khmyznikov/pwa-install"
import type { AppShellService } from "../types"

function isInsidePWA() {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false
  }

  const standaloneDisplay = window.matchMedia?.(
    "(display-mode: standalone)",
  ).matches
  const iosStandalone = Boolean(
    (navigator as Navigator & { standalone?: boolean }).standalone,
  )
  return standaloneDisplay || iosStandalone
}

function supportsPwaUpdates() {
  // Browser tabs can have a service worker too. The display mode only
  // controls the PWA body styling, not whether update checks are useful.
  return __FIELDBOOK_TARGET__ !== "capacitor"
}

export const appShell: AppShellService = {
  supportsPwaUpdates,
  platform() {
    return "web"
  },
  prepareDocument() {
    // Persistent storage is requested (and reported to Sentry) by
    // lib/storageHealth.ts at startup.
    if (isInsidePWA()) {
      document.body.classList.add("pwa")
    }
  },
}
